<template>
  <section class="mt-5">
    <h2>ショッピングクラブ会員登録申込</h2>
    <div class="form-navi mb-5">
      <ul class="d-flex">
        <li>申込入力</li>
        <li class="here">内容確認</li>
        <li>送信完了</li>
      </ul>
    </div>
    <div class="form-content">
      <h3>申込内容確認</h3>
      <p>
        以下のメールアドレスに「申込者情報の登録及び商品ご購入のお手続き」用のURLが記載されたメールをお送りいたします。<br />ご確認のうえ、「送信する」ボタンを押してください。
      </p>
      <div class="form-member my-5">
        <div class="inner">
          <form>
            <dl id="dlConfirm">
              <dt>メールアドレス</dt>
              <dd>info@manavis-cosme.co.jp</dd>
              <dt>ショッピング・クラブ会員規約</dt>
              <dd>同意する</dd>
              <dt>個人情報保護方針</dt>
              <dd>同意する</dd>
            </dl>
            <div class="box-p-20 text-center">
              <router-link
                :to="{ path: '/mock/influencer/serial/end' }"
                class="btn d-inline-block"
                >送信する</router-link
              >
            </div>
            <div class="box-p-20 text-center">
              <router-link
                :to="{ path: '/mock/influencer/serial' }"
                class="btn d-inline-block"
                >入力画面へ戻る</router-link
              >
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ mc-info@manavis-cosme.co.jp
    </p>
  </div>
</template>
<script>

export default {
  mounted() {
    window.scroll(0, 0);
  }
};

</script>
